// extracted by mini-css-extract-plugin
export var btn = "J_mB t_sw t_sm d_bz d_bP d_bD d_dw";
export var full = "J_wf d_w d_H";
export var hoverStyle = "J_mF";
export var zoom = "J_mG";